import { fun_PostAction } from "@/api/index";
// 默认导出
export default {
  // 数据存储对象
  data: () => {
    return {
      // 列表loading状态
      loading: false,
      // 查询表单字段
      form: {
        prjName: null, // 项目名称
      },
      // 查询表单
      formSearchList: [
        {
          type: "input",
          label: "项目名称：",
          value: "prjName",
          placeholder: "请输入",
        },
      ],
      // 表头按钮组
      btnList: [
        {
          name: "申请解锁",
          type: "success",
          icon: "document-add"
        },
      ],
      // 表格基础数据
      tableColumns: [
        {
          label: "项目名称",
          prop: "prjName",
          width: "380",
          isShow: true,
          fixed: true,
        },
        {
          label: "标段数",
          prop: "section",
          fixed: true,
          width: "80"
        },
        {
          label: "状态",
          slotName: "state",
          fixed: true,
          width: "130",
        },
        {
          label: "项目负责人（总监）",
          prop: "personName",
          fixed: true,
          width: "170"
        },
        {
          label: "招标人",
          prop: "tenderCorpName",
          width: "280"
        },
        {
          label: "招标联系人",
          prop: "tenderLinkMan",
          width: "150"
        },
        {
          label: "招标代理机构",
          prop: "tenderAgentOrganName",
          width: "280"
        },
        {
          label: "代理机构联系人",
          prop: "agencyLinkMan",
          width: "150"
        },
        {
          label: "招投标监管部门",
          prop: "regulatorsName",
          width: "300"
        },
        {
          label: "招标类别",
          prop: "tenderClassNumName",
          width: "150"
        },
        {
          label: "招标方式",
          prop: "tenderTypeNumName",
          width: "150"
        },
      ],
      // 表格数据
      tableData: [],
      // 分页
      reqPageData: {
        current: 1, // 页码
        size: 10 // 每页条数
      },
      total: 0, // 总条数
      // 勾选的数组
      multipleSelection: [],
    };
  },
  // 注册组件
  components: {
  },

  // 模板编译完成
  mounted() {
    // 获取一览
    this.fun_GetList();
  },
  // 自定义方法
  methods: {
    /**
     * 获取一览表格数据
     * @author 付翔
     */
    async fun_GetList() {
      try {
        // 打开loading
        this.loading = true;
        // 请求，获取结果集
        let res = await fun_PostAction("/projectManagerRecordUnlock/list", {
          ...this.form,
          ...this.reqPageData
        });
        // 解构res.data
        const { result, data, msg } = res.data;
        // 判断请求是否成功
        if (result) {
          // 解构data
          const { total, records } = data;
          // 回显table
          this.tableData = records;
          // 获取分页总条数
          this.total = total;
        } else {
          // 提示请求失败消息
          this.$message.error(msg);
        }
        // 关闭loading
        this.loading = false;
      } catch {
        // 关闭loading
        this.loading = false;
      }
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 滕威
     */
    fun_click(e) {
      // 调用申请解锁方法
      this.fun_UpdateRecord();
    },
    /**
     * 申请解锁的方法
     * @author shuhua
     */
    fun_UpdateRecord() {
      // 判断是否勾选
      if (this.multipleSelection && this.multipleSelection.length > 0) {
        // 如果勾选超过1条
        if (this.multipleSelection.length > 1) {
          // 提示，并清除选中数据
          this.$alert("只能选择一条数据！", "warning").then(() => {
            // 清除选中数据
            this.$refs.list.$refs.multipleTable.clearSelection();
          });
          return;
        } else {
          // 状态
          let state = this.multipleSelection[0].state;
          // 如果审核中或者审核通过
          if (state == "tj" || state == "tg") {
            this.$alert("存在已提交或已解锁的项目，不能申请解锁！", "warning");
            return;
          }
          // 跳转详情页面
          this.$router.push({
            path: "/projectManagerRecordUnlockDetail",
            query: {
              controllerFlg: "update",
              id: this.multipleSelection[0].id,
            }
          });
        }
      } else {
        // 未勾选，则提示
        this.$alert("请至少选中一行数据！", "warning");
        return;
      }
    },
    /**
     * 查询
     * @author 滕威
     */
    fun_Search() {
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_HandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.multipleSelection = e;
    },
    /**
     * 改变每页条数执行的函数
     * @params e 每页条数
     * @author 滕威
     */
    fun_LimitChange(e) {
      // 获取每页显示条数
      this.reqPageData.size = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 改变页码执行的函数
     * @params e 页码数
     * @author 滕威
     */
    fun_PageChange(e) {
      // 获取当前页码
      this.reqPageData.current = e;
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 重置
     * @author 滕威
     */
    fun_Reset() {
      // 清除查询表单
      this.$refs.list.$refs.formItem.map(e => {
        e.resetField();
      });
      // 重置分页
      this.reqPageData = {
        current: 1, // 页码
        size: 10 // 每页条数
      };
      // 获取一览表格数据
      this.fun_GetList();
    },
    /**
     * 查看详情
     * @author shuhua
     */
    fun_LookDetails(e) {
      // 请求参数
      let obj = {
        controllerFlg: "detail",
        id: e.val.id
      }
      // 跳转详情页面
      this.$router.push({
        path: "/projectManagerRecordUnlockDetail",
        query: obj,
      });
    },
  }
};
